module.exports = __webpack_public_path__ + "img/unconscious.e66d10c.jpg";